:root:has(body.semantic-layer) {
  scroll-behavior: smooth;
}

body.semantic-layer {
  .hero.product-shot-inline {
    gap: 90px;
    grid-template-columns: 39% 1fr;

    --max-image-size: 660px;

    h1 {
      margin-bottom: var(--size4);
      max-width: 25rem;
    }

    h2 {
      margin-bottom: var(--size8);
    }

    .dashboard-image-mobile {
      display: none;
    }

    @media screen and (width < 1090px) {
      grid-template-columns: 1fr;

      .dashboard-image {
        width: 100%;
      }
    }

    @media screen and (width < 900px) {
      gap: 40px;
      padding-block: var(--size8);

      h1 {
        margin-bottom: 0;
      }

      h2 {
        font-size: var(--size4);
        margin-bottom: var(--size4);
      }

      .dashboard-image-desktop {
        display: none;
      }

      .dashboard-image-mobile {
        display: block;
      }
    }

    @media screen and (width < 900px) {
      hgroup {
        align-items: flex-start;
        text-align: left;
      }
    }
  }

  .semantic-layer {
    padding-inline: var(--size4);

    .caps-s {
      color: #ce075f;
      display: block;
      font-size: 13px;
      margin-bottom: 20px;
    }

    .centered-section-title {
      padding-block: var(--size10);
    }

    .centered-section-title h2 {
      margin-bottom: 21px;
    }

    &-inner {
      margin-inline: auto;
      max-width: 86rem;

      p {
        margin: var(--size2) auto;
        margin-bottom: var(--size5);
        max-width: 60rem;
      }
    }

    @media screen and (width < 900px) {
      .centered-section-title {
        padding-block: var(--size14) var(--size8);
        text-align: left;

        h2 {
          font-size: var(--size8);
        }

        p {
          margin-inline: 0;
        }
      }

      .body-l {
        font-size: var(--size4);
      }
    }
  }

  /* ponytail: copied from .marquee.home-insights-marquee (home page),
     minus its dark background + white-logo invert — this section sits on
     the light page background, so logos stay their natural color. */
  .marquee {
    margin: 0;
    padding-block: 0;

    /* base customers-marquee.css hides this by default; this page wants it
       shown as a small label above the logos. */
    .centered-section-title {
      display: block;
      padding-bottom: var(--size2);

      h3 {
        color: #818181;
        font-size: var(--font-xs);
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
    }

    .marquee--content {
      flex-shrink: 0;
      gap: clamp(2.25rem, 6vw, 4.5rem);
      max-width: none;
      padding-left: clamp(2.25rem, 6vw, 4.5rem);
      width: max-content;
    }

    @media screen and (width < 900px) {
      padding-block: 0;

      .marquee--inner {
        padding-top: 0;
      }
    }
  }

  .trust-rows {
    border: 1px solid #efe9e3;
    margin-top: var(--size15);
    padding-block: 70px 107px;

    &-inner {
      margin-inline: auto;
      max-width: 86rem;
      padding: 0 var(--page-width-padding-inline);

      &.trust-rows-inner h2 {
        margin-bottom: var(--size4);
      }

      > p {
        margin-bottom: 58px;
      }

      .caps-s {
        color: #ce075f;
        display: block;
        margin-bottom: 20px;
        padding-inline: var(--size2);
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 5px;
      list-style: none;
      margin: 0;
      padding-inline: var(--size2);
      padding-top: var(--size2);
    }

    /* stylelint-disable-next-line no-descending-specificity */
    &__row {
      align-items: center;
      background: rgb(239 233 227 / 50%);
      border-radius: 6px;
      column-gap: var(--size6);
      cursor: pointer;
      display: grid;
      grid-template-columns: auto 12rem 1fr;
      padding: var(--size4) var(--size5);
      position: relative;
      transition: background-color 0.2s ease;

      &:hover {
        background: rgb(239 233 227 / 100%);
      }
    }

    &__row-link {
      inset: 0;
      position: absolute;
      z-index: 0;
    }

    &__icon {
      background: var(--color-pure-white-next);
      border-radius: var(--size2);
      color: var(--color-omni-pink-next);
      display: grid;
      height: var(--size12);
      place-items: center;
      width: var(--size12);

      img {
        height: 3rem;
        width: 3rem;
      }
    }

    &__label {
      align-items: center;
      display: inline-flex;
      gap: var(--size3);
      text-decoration: none;
      width: fit-content;

      svg {
        background: #ff5fa2;
        border-radius: 50%;
        color: var(--color-text-inverse-next);
        height: 18px;
        padding: 2px;
        transition: transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);
        width: 18px;
      }
    }

    .trust-rows__row:hover .trust-rows__label svg {
      transform: translateX(3px);
    }

    &__description {
      margin: 0;
      margin-left: var(--size10);

      a {
        color: var(--color-omni-pink-next);
        position: relative;
        z-index: 1;
      }
    }

    @media screen and (width < 900px) {
      padding-bottom: 93px;

      &-inner {
        padding: 0 var(--size4);
      }

      &__row {
        gap: var(--size3);
        grid-template-columns: auto 1fr;

        > p {
          grid-column: 1 / -1;
          margin-left: 0;
        }
      }
    }
  }

  .tab-accordion-full-width-hgroup {
    margin-bottom: var(--size15);
  }

  .tab-accordion-teach-ai-your-business .tab-accordion-full-width-hgroup {
    @media screen and (width < 900px) {
      margin-bottom: 1rem;
    }
  }

  .tab-accordion-full-width-hgroup .text-combo p {
    max-width: 1028px;
  }

  .tab-accordion-model-as-you-go h2 .caps-s,
  .tab-accordion-teach-ai-your-business h2 .caps-s {
    align-items: center;
    color: #ce075f;
    display: flex;
    font-size: var(--font-size-caps-s-next);
    gap: var(--size1);
    margin-bottom: 20px;
    text-decoration: none;

    &.model-as-you-go-overline,
    &.teach-ai-overline {
      gap: 18px;
    }

    .model-as-you-go-overline__icon {
      background: #fcfcf7;
      border: 1px solid #efe9e3;
      border-radius: 2px;
      height: var(--size7);
      object-fit: contain;
      width: var(--size7);
    }

    .teach-ai-overline__icon {
      border: 1px solid #efe9e3;
      border-radius: 2px;
      height: var(--size7);
      object-fit: contain;
      width: var(--size7);
    }
  }

  .tab-accordion-model-as-you-go,
  .tab-accordion-teach-ai-your-business {
    --tab-accordion-content-width: 464px;
  }

  .tab-accordion-section {
    border-bottom: none;
  }

  @media screen and (width >= 1024px) {
    .tab-accordion-section {
      padding-bottom: 0;
    }
  }

  @media screen and (width < 1024px) {
    .tab-accordion-section {
      margin-bottom: var(--size10);
      padding-bottom: 0;
    }
  }

  .tab-accordion-model-as-you-go.tab-accordion-model-as-you-go.tab-accordion-model-as-you-go {
    margin-inline: auto;
    max-width: 86rem;
  }

  /* ponytail: min-height estimate of the tallest expanded item, since it
     can't be measured without rendering — keeps the accordion from jumping
     as items expand/collapse; nudge to taste. */
  .tab-accordion-model-as-you-go .tab-accordion-tabs {
    min-height: 520px;
  }

  @media screen and (width >= 1024px) {
    .tab-accordion-model-as-you-go .tab-accordion-layout,
    .tab-accordion-teach-ai-your-business .tab-accordion-layout {
      align-items: start;
    }

    .tab-accordion-model-as-you-go .tab-accordion-nav-arrows {
      bottom: var(--size4);
      right: var(--size28);
    }

    .tab-accordion-teach-ai-your-business .tab-accordion-nav-arrows {
      display: none;
    }
  }

  @media screen and (width < 1024px) {
    .tab-accordion-model-as-you-go .tab-accordion-layout,
    .tab-accordion-teach-ai-your-business .tab-accordion-layout {
      gap: 0;
    }

    .tab-accordion-wrapper.tab-accordion-model-as-you-go,
    .tab-accordion-wrapper.tab-accordion-teach-ai-your-business {
      padding: 0 var(--size4);
    }
  }

  .tab-accordion-model-as-you-go .tab-accordion-screenshots,
  .tab-accordion-teach-ai-your-business .tab-accordion-screenshots {
    aspect-ratio: auto;
    height: 395px;
    margin-right: 0;
    max-width: 704px;
    width: 100%;
  }

  .tab-accordion-model-as-you-go .tab-accordion-screenshots {
    background: var(--color-pure-white-next);
    box-shadow:
      0 18px 40px 0 #0000001a,
      0 449px 126px 0 #0000;
  }

  .tab-accordion-model-as-you-go .tab-accordion-screenshot-media {
    object-position: center;
    padding-inline: var(--size3);
  }

  .tab-accordion-teach-ai-your-business .tab-accordion-screenshots {
    background: transparent;
    border-radius: var(--size4);
  }

  @media screen and (width < 1024px) {
    .tab-accordion-model-as-you-go .tab-accordion-screenshots,
    .tab-accordion-teach-ai-your-business .tab-accordion-screenshots {
      display: grid;
      height: auto;
      margin-bottom: var(--size6);
      max-width: unset;
      order: -1;
      padding-block: 14px;
    }

    .tab-accordion-teach-ai-your-business .tab-accordion-screenshots {
      margin-bottom: 0;
    }

    .tab-accordion-model-as-you-go .tab-accordion-screenshot-inline,
    .tab-accordion-teach-ai-your-business .tab-accordion-screenshot-inline {
      display: none;
    }
  }

  .tab-accordion-teach-ai-your-business {
    .tab-accordion-screenshot {
      .teach-ai-screenshot-image {
        display: block;
        height: 100%;
        object-fit: contain;
        width: 100%;
      }
    }
  }

  .synthesia-callout.synthesia-callout .callout-illustration img {
    border: 7px solid #efe9e3;
    border-radius: var(--size4);
    width: 576px;
  }

  .synthesia-callout .callout-list .callout-illustration {
    position: relative;
    z-index: 3;
  }

  .synthesia-callout.synthesia-callout .callout {
    align-items: start;
    gap: var(--size24);
    justify-content: flex-start;
    padding: var(--size5);
  }

  .synthesia-callout.synthesia-callout .callout-text {
    margin-top: var(--size8);
    max-width: 435px;

    hgroup {
      display: flex;
      flex-direction: column;

      /* stylelint-disable-next-line no-descending-specificity */
      p {
        margin-bottom: 27px;
      }
    }

    h4 {
      font-size: 30px;
    }

    @media screen and (width < 900px) {
      hgroup {
        gap: 0;
      }
    }
  }

  .synthesia-callout {
    background: rgb(239 233 227 / 70%);
    border-radius: 15px;
    margin-top: var(--size24);
    max-width: 1216px;
    padding: 0;

    .callout-list {
      margin-inline: auto;
      max-width: 1120px;
      padding-bottom: 50px;
      padding-top: 50px;
    }

    @media screen and (width < 900px) {
      margin: 0 var(--size4);
      margin-bottom: 64px;

      .callout-list {
        padding-bottom: 35px;
        padding-top: 0;

        p,
        ol,
        ul {
          margin-bottom: var(--size4);
        }
      }
    }

    @media screen and (width < 1000px) {
      &.synthesia-callout .callout {
        flex-direction: column;
        gap: 0;
      }
    }
  }

  @media screen and (width < 64rem) {
    .quote-section.quote-carousel {
      overflow: visible;

      blockquote.quote-carousel__quote {
        font-size: 15px;
        margin-top: calc(-1 * var(--size18));
        padding: var(--size5);
        padding-top: 38px;
      }

      .quote-carousel__partner {
        height: 82px;
        width: 142px;

        &::before {
          height: 82px;
          left: calc(100% + var(--size8));
        }

        .quote-carousel__logo {
          left: calc(150% + var(--size8));
          top: 42px;
        }
      }

      .quote-carousel__quote cite {
        white-space: pre-line;
      }
    }
  }

  .synthesia-callout .quote-section.quote-carousel {
    overflow: visible;
    padding-block: 0;

    .quote-carousel__quote {
      cite {
        white-space: pre-line;
      }
    }

    @media screen and (width < 64rem) {
      padding-bottom: 28px;

      .quote-section.quote-carousel {
        padding-block: 0;
      }

      .quote-carousel__slide {
        padding-bottom: 0;
      }
    }

    @media screen and (width >= 64rem) {
      position: relative;
      top: -45px;
      z-index: 2;

      .page-section__inner.quote-carousel__inner {
        padding-right: 73px;
      }

      .quote-carousel__quote {
        background: rgb(252 252 247 / 65%);
        padding: var(--size24) var(--size19) var(--size12) 147px;
        position: relative;
        top: calc(-1 * var(--size15));
        z-index: 1;

        p {
          font-size: var(--size5);
        }
      }

      .quote-carousel__slide {
        grid-template-columns: minmax(15rem, 0.24fr) minmax(0, 0.76fr);
      }

      .quote-carousel__partner {
        min-height: 10.5rem;
        position: relative;
        z-index: 2;

        &::before {
          top: 42%;
        }
      }

      .quote-carousel__logo {
        top: 42%;
      }
    }
  }

  .universal-semantics-diagram {
    background: var(--color-pure-white-next);
    border: 1.295px solid #f2e9e1;
    border-radius: 31.068px;
    box-shadow: 0 12.945px 38.836px 0 rgb(38 2 17 / 10%);
    overflow: hidden;

    @supports (color: color(display-p3 1 1 1)) {
      border-color: color(display-p3 0.9373 0.9137 0.8902);
      box-shadow: 0 12.945px 38.836px 0
        color(display-p3 0.1333 0.0157 0.0667 / 10%);
    }
  }

  .existing-investments.existing-investments .callout-illustration img,
  .extend-model.extend-model .callout-illustration img {
    border-radius: var(--size4);
  }

  @media screen and (width >= 1000px) {
    .existing-investments.existing-investments .callout-illustration,
    .extend-model.extend-model .callout-illustration {
      width: 610px;
    }

    .existing-investments.existing-investments .callout-illustration img,
    .extend-model.extend-model .callout-illustration img {
      width: 610px;
    }

    .existing-investments.existing-investments .callout-text,
    .extend-model.extend-model .callout-text {
      width: 421px;
    }
  }

  .existing-investments,
  .extend-model {
    border-top: 1px solid #efe9e3;
    margin-top: 64px;
    padding-top: 64px;

    .callout-list {
      display: flex;
      flex-direction: column;
      gap: var(--size28);

      h3 {
        font-size: var(--font-size-heading-xxl-next);
      }
    }

    .callout-list .callout {
      align-items: start;
      display: grid;
      grid-template-areas: 'heading' 'media' 'text';
      grid-template-columns: 1fr;
      padding-block: 0;

      .callout-heading {
        grid-area: heading;
        margin-bottom: var(--size4);
      }

      .callout-illustration {
        grid-area: media;
      }

      .callout-text {
        grid-area: text;
      }
    }

    @media screen and (width >= 1000px) {
      .callout-list .callout:nth-of-type(odd) {
        gap: 0 var(--size15);
        grid-template-areas: 'media heading' 'media text';
        grid-template-columns: 610px 1fr;
        grid-template-rows: minmax(0, auto) 1fr;
      }

      .callout-list .callout:nth-of-type(even) {
        gap: 0 var(--size15);
        grid-template-areas: 'heading media' 'text media';
        grid-template-columns: 1fr 610px;
        grid-template-rows: minmax(0, auto) 1fr;
      }
    }

    @media screen and (width < 1000px) {
      .callout-list {
        gap: var(--size1);
      }

      .callout-list .callout {
        gap: var(--size4);
        margin-top: 50px;
      }

      .callout-list p,
      .callout-list ol,
      .callout-list ul {
        margin-top: var(--size1);
      }
    }

    .section-header {
      align-items: flex-start;
      margin-bottom: 0;
      text-align: left;

      .caps-s {
        color: #ce075f;
        display: block;
        font-size: 13px;
        margin-bottom: var(--size5);
      }

      .existing-investments-overline,
      .extend-model-overline {
        align-items: center;
        display: flex;
        gap: 18px;
        text-decoration: none;
      }

      .existing-investments-overline__icon,
      .extend-model-overline__icon {
        background: #fcfcf7;
        border: 1px solid #efe9e3;
        border-radius: 2px;
        height: var(--size7);
        width: var(--size7);
      }

      h3 {
        margin-bottom: var(--size4);
      }
    }
  }

  .extend-model {
    background: #efe9e3;
    padding-block: var(--size24);

    @media screen and (width < 900px) {
      padding-block: 46px;
    }
  }

  /* stylelint-disable no-descending-specificity */
  .governance-speed {
    --timeline-x: 0.3rem;
    --timeline-dot-size: 0.65rem;

    border-bottom: 1px solid var(--color-border-light-next);
    padding: var(--size24) 0 8.75rem;

    &__inner {
      margin-inline: auto;
      max-width: 86rem;
    }

    &__header {
      margin-bottom: 6rem;
      max-width: 58rem;

      h2 {
        color: #5c002e;
        margin: var(--size4) 0;
        max-width: 48rem;
      }

      p {
        color: #5c002e;
        font-size: var(--font-lg);
        line-height: 27.55px;
        margin: 0;
        max-width: 58rem;
      }
    }

    &__eyebrow {
      align-items: center;
      color: #f6005e;
      display: flex;
      gap: 1.125rem;
      margin-bottom: 20px;
      text-transform: uppercase;
    }

    &__eyebrow-icon {
      align-items: center;
      display: inline-flex;
      height: 28px;
      justify-content: center;
      width: 28px;

      img {
        border: 1px solid #efe9e3;
        border-radius: 2px;
        display: block;
        height: auto;
        width: 100%;
      }
    }

    &__rows {
      position: relative;
    }

    &__row {
      display: grid;
      gap: var(--size4) 4.5rem;
      grid-template-areas:
        'title visual'
        'copy visual';
      grid-template-columns: minmax(15rem, 18rem) minmax(0, 1fr);
      grid-template-rows: auto 1fr;
      opacity: 0.18;
      padding: 0 0 5.65rem 2.5rem;
      position: relative;
      transition: opacity 300ms ease;

      &::before {
        background: #bababa;
        border-radius: 50%;
        content: '';
        height: var(--timeline-dot-size);
        left: var(--timeline-x);
        position: absolute;
        top: 0.35rem;
        transform: translate(-50%, -50%);
        transition: background 300ms ease;
        width: var(--timeline-dot-size);
        z-index: 2;
      }

      &::after {
        background: #f2e9e1;
        bottom: -0.35rem;
        content: '';
        left: var(--timeline-x);
        position: absolute;
        top: 0.35rem;
        transform: translateX(-50%);
        width: 1px;
        z-index: 1;
      }

      &[data-active='true'] {
        opacity: 1;

        &::before {
          background: #ff36a5;
        }
      }

      &:last-child {
        padding-bottom: 0;

        &::after {
          display: none;
        }
      }
    }

    &__row-title {
      color: #5c002e;
      grid-area: title;
      margin: 0;
    }

    &__row-copy {
      grid-area: copy;

      p {
        color: #2a0011;
        line-height: 1.45;
        margin: 0;
      }
    }

    &__link {
      color: #f6005e;
      text-decoration: underline;
      text-underline-offset: auto;
    }

    &__visual {
      align-self: start;
      grid-area: visual;

      img {
        display: block;
        height: auto;
        max-width: 100%;
        width: 100%;
      }
    }

    @media screen and (width < 900px) {
      padding-block: var(--size16);

      &__header {
        margin-bottom: var(--size14);

        h2 {
          font-size: 2.375rem;
          line-height: 100%;
          margin-bottom: var(--size5);
        }

        p {
          font-size: 1rem;
          line-height: 140%;
        }
      }

      &__row {
        gap: var(--size5);
        grid-template-areas:
          'title'
          'visual'
          'copy';
        grid-template-columns: minmax(0, 1fr);
        opacity: 1;
        padding: 0 0 var(--size16);

        &::before,
        &::after {
          display: none;
        }

        &:last-child {
          padding-bottom: 0;
        }
      }

      &__visual {
        width: 100%;
      }

      &__row-copy {
        p {
          font-size: 0.875rem;
        }
      }
    }
  }
  /* stylelint-enable no-descending-specificity */
}
